import React, { useCallback, useEffect, useState } from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart, Area, PieChart, Pie } from "recharts";
import { Card, Grid } from "@mui/material";
import MDTypography from "../../Components/MDTypography";
import AppLoading from "../../Components/MDLoading";
import MDBox from "../../Components/MDBox";
import { StatisticsModel } from "../../Api/Models/StatisticsModel";

interface IData {
  nosaziTotal: { name: string; count: string | number }[];
  senfTotal: { name: string; count: string | number }[];
}
export default function MainPage() {
  const [loading, setLoading] = useState(false);
  const statisticsModel = new StatisticsModel();
  const [data, setData] = useState<IData | null>({
    nosaziTotal: [],
    senfTotal: [],
  });
  useEffect(() => {
    statisticsModel
      .getAll()
      .then(async (r) => {
        let datas = r.data.data as IData;
        await setData(monthConverter(datas));
        setLoading(false);
      })
      .catch((r) => {
        setLoading(false);
      });
    return () => {};
  }, []);
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <Card sx={{ border: 1, padding: "5px 10px" }}>
          <MDTypography fontSize={12}>{`${label} : ${payload[0].value}`}</MDTypography>
        </Card>
      );
    }

    return null;
  };

  const monthConverter = useCallback((props: IData) => {
    let newData: IData = { nosaziTotal: [], senfTotal: [] };
    const intToMonth = (prop: string) => {
      let name = "";
      switch (prop) {
        case "01":
          name = "فروردین";
          break;
        case "02":
          name = "اردیبهشت";
          break;
        case "03":
          name = "خرداد";
          break;
        case "04":
          name = "تیر";
          break;
        case "05":
          name = "مرداد";
          break;
        case "06":
          name = "شهریور";
          break;
        case "07":
          name = "مهر";
          break;
        case "08":
          name = "آبان";
          break;
        case "09":
          name = "آذر";
          break;
        case "10":
          name = "دی";
          break;
        case "11":
          name = "بهمن";
          break;
        case "12":
          name = "اسفند";
          break;

        default:
          name = "";
          break;
      }
      return name;
    };
    props.nosaziTotal.forEach((el) => {
      newData.nosaziTotal.push({
        count: parseInt(el.count.toString()),
        name: intToMonth(el.name),
      });
    });
    props.senfTotal.forEach((el) => {
      newData.senfTotal.push({
        count: parseInt(el.count.toString()),
        name: intToMonth(el.name),
      });
    });
    return newData;
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar name={"صفحه اصلی"} />
      {!loading && (
        <MDBox bgColor="white" p={2} mb={2} borderRadius={2}>
          <Grid container spacing={2}>
            <Grid container xs={12} lg={12} sm={12} item sx={{ background: "white" }} flexDirection={"column"}>
              <Card sx={{ width: "100%" }}>
                <Grid item sx={{ background: "black" }} borderRadius={"10px 10px 0 0"}>
                  <MDTypography m={1} color="white">
                    تعداد قبوض نوسازی{" "}
                  </MDTypography>
                </Grid>

                {data?.nosaziTotal && data?.nosaziTotal.length < 1 ? (
                  <Grid container justifyContent={"center"} flex={1} sx={{ minHeight: 250, background: "white" }}>
                    <MDTypography alignSelf="center">هیچ دیتایی وجود ندارد</MDTypography>
                  </Grid>
                ) : (
                  <Grid item flex={1} sx={{ minHeight: 250, background: "white" }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart
                        width={500}
                        height={300}
                        data={data?.nosaziTotal}
                        style={{
                          direction: localStorage.getItem("_lu") || "ltr",
                        }}
                        margin={{
                          top: 20,
                          right: 30,
                          left: 20,
                          bottom: 30,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" interval={0} angle={30} dx={20} dy={15} reversed={true} fontSize={12} />
                        <YAxis orientation={"right"} fontSize={12} />
                        <Tooltip content={<CustomTooltip />} />
                        <Area type="monotone" dataKey="count" stroke="#8884d8" fill="#8884d8" activeDot={{ r: 8 }} />
                      </AreaChart>
                    </ResponsiveContainer>
                  </Grid>
                )}
              </Card>
            </Grid>
            <Grid container item xs={12} lg={12} sm={12} sx={{ background: "white" }} flexDirection={"column"}>
              <Card sx={{ width: "100%" }}>
                <Grid item sx={{ background: "black" }} borderRadius={"10px 10px 0 0"}>
                  <MDTypography m={1} color="white">
                    تعداد قبوض صنف
                  </MDTypography>
                </Grid>
                {data?.senfTotal && data?.senfTotal.length < 1 ? (
                  <Grid container justifyContent={"center"} flex={1} sx={{ minHeight: 250, background: "white" }}>
                    <MDTypography alignSelf="center">هیچ دیتایی وجود ندارد</MDTypography>
                  </Grid>
                ) : (
                  <Grid item flex={1} sx={{ minHeight: 250, background: "white" }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart
                        width={500}
                        height={300}
                        data={data?.senfTotal}
                        style={{
                          direction: localStorage.getItem("_lu") || "ltr",
                        }}
                        margin={{
                          top: 20,
                          right: 30,
                          left: 20,
                          bottom: 30,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" interval={0} angle={30} dx={20} dy={15} reversed={true} fontSize={12} />
                        <YAxis orientation={"right"} fontSize={12} />
                        <Tooltip content={<CustomTooltip />} />
                        <Area type="monotone" dataKey="count" stroke="#8884d8" fill="#8884d8" activeDot={{ r: 8 }} />
                      </AreaChart>
                    </ResponsiveContainer>
                  </Grid>
                )}
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
